module.exports = __webpack_public_path__ + "static/media/feature4.b1028a66.png";